module.exports = __webpack_public_path__ + "static/media/tallink.494db9df.png";